import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Mail } from "lucide-react";
import { SOCIALS, LOCATION, LOGO, ORG, CONTACT_EMAIL } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2b1c10] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Brand + tagline */}
          <div className="md:col-span-7">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO} alt="Mechelen Beach" className="h-28 sm:h-32 w-auto" />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-white/75 max-w-lg">
              Vakantie in eigen stad. Strandbar, sport en sfeer voor jong en oud – op het Douaneplein in Mechelen.
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              <a
                href={SOCIALS.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                data-testid="footer-social-facebook"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#ff7a1a] via-[#ed6a1a] to-[#c54508] text-white shadow-[0_6px_14px_-4px_rgba(237,106,26,0.6)] hover:scale-110 transition-transform"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={SOCIALS.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-social-instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#ff7a1a] via-[#ed6a1a] to-[#c54508] text-white shadow-[0_6px_14px_-4px_rgba(237,106,26,0.6)] hover:scale-110 transition-transform"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Location + email — stacked vertically (right-aligned on desktop) */}
          <div className="md:col-span-5 flex flex-col items-start md:items-end gap-2.5 md:pt-2">
            <a
              href={LOCATION.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-location-link"
              className="inline-flex items-center gap-2.5 text-sm text-white/85 hover:text-white"
            >
              <MapPin className="h-4 w-4 text-[#ed6a1a] shrink-0" />
              <span>Douaneplein / Transit M, Mechelen</span>
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="inline-flex items-center gap-2.5 text-sm text-white/85 hover:text-white"
            >
              <Mail className="h-4 w-4 text-[#ed6a1a] shrink-0" />
              <span>{CONTACT_EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-white/10 flex flex-col gap-1 text-xs text-white/60">
          <p data-testid="footer-copyright">
            Copyright {ORG.name} – {ORG.street}, {ORG.postal} {ORG.city}
          </p>
          <p>Alle rechten voorbehouden.</p>
        </div>
      </div>
    </footer>
  );
}
